import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

//import image from "../../../images/state_revenue_by_source.png";

const StateRevenueSourcesGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "state_revenue_by_source.png" }) {
        childImageSharp {
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img fluid={data.placeholderImage.childImageSharp.fluid} />
}

export default StateRevenueSourcesGraphic
